import{injectFontFallbacks as e}from"./inject-font-fallbacks.js";const t=t=>e(t);export{t as applyFontFallbacksString};
//# sourceMappingURL=apply-font-fallbacks-string.js.map